<template>
  <div class="position-relative" style="width: 600px;">
    <div class="d-flex">
      <div class="client-form-container position-relative w-100 bg-white">
        <b-tabs v-model="activeTab">
          <b-tab title="Patient Info">
            <div class="bg-extra-light-gray section-title rounded">
              <h6 class="mb-0">
                Demographics
              </h6>
            </div>
            <div class="section-body">
              <b-row>
                <b-col>
                  <div
                    class="d-flex flex-row justify-content-start align-items-start h-100 mb-2"
                  >
                    <div
                      class="d-flex flex-row justify-content-start align-items-center"
                    >
                      <div
                        class="picture-preview mr-4"
                        style="width: 152px; height: 152px;"
                      >
                        <img
                          :src="
                            avatar
                              ? avatar
                              : require(`../../assets/avatar-example.png`)
                          "
                        />
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <b-form-group label="First Name">
                    {{ form.firstName }}
                  </b-form-group>
                  <b-form-group label="Middle Name">
                    {{ form.middleName }}
                  </b-form-group>
                  <b-form-group label="Last Name">
                    {{ form.lastName }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="DOB">
                    {{ form.dateOfBirth }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="MR#">
                    {{ form.mrn }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="SSN"
                    v-if="hasCurrentUserPermissionAccess('patients', 'ssn')"
                  >
                    {{ form.ssn }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group v-if="form.gender" label="Legal Sex">
                    {{ form.gender.label }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Other Phone">
                    {{ form.landLineNumber }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Mobile Phone number">
                    {{ form.phone }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Email">
                    {{ form.email }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Address Line 1" trim>
                    {{ form.addressLine1 }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Address Line 2">
                    {{ form.addressLine2 }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group v-if="form.city" label="City">
                    {{ form.city }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group v-if="form.state" label="State">
                    {{ form.state.label }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Zipcode">
                    {{ form.zipcode }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    v-if="form.maritalStatus"
                    label="Marital Status"
                  >
                    {{ form.maritalStatus.label }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group v-if="form.race" label="Race">
                    {{ form.race.label }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Occupation">
                    {{ form.occupation }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group v-if="form.ethnicity" label="Ethnicity">
                    {{ form.ethnicity.label }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group v-if="form.language" label="Language">
                    {{ form.language.label }}
                  </b-form-group>
                </b-col>
                <b-col></b-col>
              </b-row>
            </div>
            <div class="bg-extra-light-gray rounded section-title">
              <h6 class="mb-0">Episode of care</h6>
            </div>
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group v-if="form.startDate" label="Start Date">
                    {{ form.startDate }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group v-if="form.endDate" label="End Date">
                    {{ form.endDate }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Mrn Suffix">
                    {{ form.eocn }}
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    v-if="form.referralSource"
                    label="Referral Source"
                  >
                    {{ form.referralSource }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    v-if="primaryProviderForm"
                    label="Primary Provider"
                  >
                    {{ primaryProviderForm.label }}
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div class="bg-extra-light-gray rounded section-title">
              <h6 class="mb-0">Additional Information</h6>
            </div>
            <div class="px-2 section-body">
              <div class="text-left">
                <div class="builder w-100">
                  <li v-for="field in additionalDataFields" :key="field">
                    <b-form-group>
                      <template v-slot:label>
                        {{ field }}
                      </template>
                      {{ form.additionalsReportResults[field] }}
                    </b-form-group>
                  </li>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Insurance">
            <div class="bg-extra-light-gray rounded section-title">
              <h6 class="mb-0">Insurances</h6>
            </div>
            <div class="section-body">
              <b-row>
                <b-col>
                  <div v-if="insuranceItems.length > 0">
                    <data-card
                      hideActions="hideActions"
                      :cardInfo="insurance"
                      v-for="insurance in insuranceItems"
                      :key="insurance.itemIndex"
                    />
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-center color-custom-grey"
                  >
                    No insurance information.
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab title="Allergies">
            <div class="bg-extra-light-gray rounded section-title">
              <h6 class="mb-0">Allergies</h6>
            </div>
            <div class="section-body">
              <b-row>
                <b-col>
                  <div v-if="allergyItems.length > 0">
                    <data-card
                      hideActions="hideActions"
                      :cardInfo="allergy"
                      v-for="(allergy, allergyIndex) in allergyItems"
                      :key="allergyIndex"
                    />
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-center color-custom-grey"
                  >
                    No allergy information.
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Contacts">
            <div class="bg-extra-light-gray rounded section-title">
              <h6 class="mb-0">Contacts</h6>
            </div>
            <div class="section-body">
              <b-row>
                <b-col>
                  <div v-if="contactItems.length">
                    <data-card
                      v-for="(contact, contactIndex) in contactItems"
                      :cardInfo="contact"
                      :key="contactIndex"
                      hideActions="hideActions"
                    />
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-center color-custom-grey"
                  >
                    No contact information.
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Guarantors">
            <div class="bg-extra-light-gray rounded section-title">
              <h6 class="mb-0">Guarantors</h6>
            </div>
            <div class="section-body">
              <b-row>
                <b-col>
                  <div v-if="guarantorItems.length">
                    <data-card
                      v-for="(guarantor, guarantorIndex) in guarantorItems"
                      :cardInfo="guarantor"
                      :key="guarantorIndex"
                      hideActions="hideActions"
                    />
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-center color-custom-grey"
                  >
                    No guarantor information.
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import eocServer from "../../server/eoc";
import patientServer from "../../server/patient";
import avatarServer from "../../server/avatar";
import { formatDate, formatDateOnly } from "../../helpers/date";
import DataCard from "../controls/DataCard";
import { formatUser } from "../../helpers/user";

export default {
  name: "EocPickerPatientData",
  components: {
    DataCard
  },
  props: ["eocId"],
  data() {
    return {
      eocEditId: this.eocId,
      form: {
        firstName: null,
        middleName: null,
        lastName: null,
        dateOfBirth: null,
        email: "",
        landLineNumber: "",
        phone: "",
        ssn: "",
        gender: null,
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: null,
        zipcode: "",
        insurances: [],
        contacts: [],
        guarantors: [],
        allergies: [],
        startDate: "",
        endDate: null,
        mrn: "",
        eocn: "",
        referralSource: "",
        caseLoads: [],
        primaryProvider: null,
        maritalStatus: null,
        race: null,
        ethnicity: null,
        language: null,
        occupation: "",
        additionalsReportResults: {}
      },
      avatar: null,
      formAdditionalInfo: {},
      activeTab: 0,
      dataLoaded: false
    };
  },
  async mounted() {
    this.activeTab = this.initialTab ?? 0;
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.initializeClientForm();
      this.dataLoaded = true;
    },
    async initializeClientForm() {
      const eoc = await eocServer.get(this.eocEditId);
      const ssn = await patientServer.getSSN(eoc.patient.id);
      const primaryProvider = eoc.caseLoads.find(
        cL => cL.caseRole && cL.caseRole.type == "PrimaryProvider"
      );
      this.form = {
        firstName: eoc.patient.firstName,
        middleName: eoc.patient.middleName,
        lastName: eoc.patient.lastName,
        dateOfBirth: eoc.patient.dateOfBirth
          ? formatDateOnly(eoc.patient.dateOfBirth)
          : "",
        email: eoc.patient.email,
        landLineNumber: eoc.patient.landLineNumber,
        phone: eoc.patient.phone,
        ssn: ssn,
        gender: eoc.patient.gender
          ? {
              value: eoc.patient.gender.id,
              label: eoc.patient.gender.name
            }
          : null,
        addressLine1: eoc.patient.addressLine1,
        addressLine2: eoc.patient.addressLine2,
        city: eoc.patient.city,
        state: eoc.patient.state
          ? {
              value: eoc.patient.state.id,
              label: eoc.patient.state.name
            }
          : null,
        zipcode: eoc.patient.zipcode,
        insurances: eoc.patient.insurances.map(insurance => ({
          ...insurance,
          relationship: insurance.patientRelationship,
          coverage: insurance.insuranceCoverage,
          effectiveDateStart: insurance.effectiveDateFrom,
          effectiveDateEnd: insurance.effectiveDateTo,
          coInsurance: insurance.coInsurancePercent
        })),
        contacts: eoc.patient.contacts,
        guarantors: eoc.patient.guarantors,
        allergies: eoc.patient.allergies,
        caseLoads: eoc.caseLoads ? eoc.caseLoads : [],
        startDate: eoc.startDate ? formatDate(eoc.startDate) : "",
        endDate: eoc.endDate ? formatDate(eoc.endDate) : null,
        mrn: eoc.patient.mrn,
        eocn: eoc.eocn,
        referralSource: eoc.referralSource,
        additionalsResults: eoc.additionalsResults,
        additionalsReportResults: eoc.additionalsReportResults,
        primaryProvider: primaryProvider
          ? {
              value: primaryProvider.user.id,
              label: formatUser(primaryProvider.user)
            }
          : null,
        maritalStatus: eoc.patient.maritalStatus
          ? {
              value: eoc.patient.maritalStatus.id,
              label: eoc.patient.maritalStatus.name
            }
          : null,
        race: eoc.patient.race
          ? {
              value: eoc.patient.race.id,
              label: eoc.patient.race.name
            }
          : null,
        ethnicity: eoc.patient.ethnicity
          ? {
              value: eoc.patient.ethnicity.id,
              label: eoc.patient.ethnicity.name
            }
          : null,
        language: eoc.patient.language
          ? {
              value: eoc.patient.language.id,
              label: eoc.patient.language.name
            }
          : null,
        occupation: eoc.patient.occupation
      };
      if (eoc.patient.avatarId) {
        avatarServer
          .downloadUrl(eoc.patient.avatarId)
          .then(response => {
            this.avatar = response;
          })
          .catch(() => {});
      }
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    ...mapState("client", {
      caseRoles: state =>
        state.caseRoles.map(caseRole => ({
          value: caseRole.id,
          label: caseRole.name,
          data: caseRole
        }))
    }),
    insuranceItems() {
      return this.form.insurances.map((item, itemIndex) => {
        let insuredAddressComponents = [];
        if (item.insuredAddressLine1 || item.insuredAddressLine2)
          insuredAddressComponents.push(
            `${item.insuredAddressLine1}${
              item.insuredAddressLine2 ? " " + item.insuredAddressLine2 : ""
            }`
          );
        if (item.insuredCity)
          insuredAddressComponents.push(`${item.insuredCity}`);
        if (item.insuredState)
          insuredAddressComponents.push(`${item.insuredState.name}`);
        if (item.insuredZipcode)
          insuredAddressComponents.push(`${item.insuredZipcode}`);
        let insuredAddressData = insuredAddressComponents.join(", ");

        return {
          itemIndex: itemIndex,
          data: item,
          title:
            (item.primary
              ? "Primary"
              : item.secondary
              ? "Secondary"
              : item.tertiary
              ? "Tertiary"
              : "Other") +
            (item.company ? " | " : "") +
            (item.company ? item.company.name : ""),
          extraData: [
            [
              `ID: ${item.memberIdent}`,
              `Plan: ${item.plan ? item.plan.name : ""}`,
              `Group: ${item.groupNo}`,
              `Relationship: ${
                item.relationship ? item.relationship.name : ""
              }`,
              ...(item.relationship.name == "Self"
                ? []
                : [
                    `Insured Name: ${item.insuredFirstName} ${
                      item.insuredMiddleName ? item.insuredMiddleName : ""
                    } ${item.insuredLastName ? item.insuredLastName : ""}`,
                    ...(item.insuredSsn
                      ? [`Insured SSN: ${item.insuredSsn}`]
                      : []),
                    ...(item.insuredDob
                      ? [`Insured DOB: ${formatDateOnly(item.insuredDob)}`]
                      : []),
                    ...(item.insuredAddressData
                      ? [`Insured Address: ${insuredAddressData}`]
                      : [])
                  ])
            ],
            [
              `Phone#: ${
                item.company.phoneNumber ? item.company.phoneNumber : ""
              }`,
              `Email: ${item.company.email ? item.company.email : ""}`,
              `Fax: ${item.company.fax ? item.company.fax : ""}`
            ]
          ]
        };
      });
    },
    allergyItems() {
      return this.form.allergies.map((item, itemIndex) => ({
        itemIndex,
        data: item,
        title: item.allergyType.name,
        extraData: [
          [
            `Allergen: ${
              item.allergen
                ? item.allergen.name.toLowerCase() == "other"
                  ? item.otherAllergen
                  : item.allergen.name
                : ""
            }`,
            `Reaction: ${
              item.reaction
                ? item.reaction.name.toLowerCase() == "other"
                  ? item.otherReaction
                  : item.reaction.name
                : ""
            }`,
            `Severity: ${item.severity ? item.severity.name : ""}`
          ]
        ]
      }));
    },
    contactItems() {
      return this.form.contacts.map((item, itemIndex) => {
        const data = {
          itemIndex,
          data: item,
          title: item.name,
          extraData: [
            [
              ...(item.relationship
                ? [`Relationship: ${item.relationship.name}`]
                : []),
              ...(item.phone ? [`Mobile Phone: ${item.phone}`] : []),
              ...(item.email ? [`Email: ${item.email}`] : [])
            ]
          ]
        };

        const arr = [];
        if (item.address) arr.push(item.address);
        if (item.city) arr.push(item.city);
        if (item.state) arr.push(item.state.name);
        if (item.zipCode) arr.push(item.zipCode);

        const address = arr.join(", ");
        if (address) {
          data.extraData.push([`Address: ${address}`]);
        }

        return data;
      });
    },
    guarantorItems() {
      return this.form.guarantors.map((item, itemIndex) => {
        const data = {
          itemIndex,
          data: item,
          title:
            item?.firstName + " " + item?.middleName + " " + item?.lastName,
          extraData: [
            [
              ...(item?.relationship
                ? [`Relationship: ${item?.relationship.name}`]
                : []),
              ...(item.phone ? [`Mobile Phone: ${item.phone}`] : []),
              ...(item?.email ? [`Email: ${item?.email}`] : [])
            ]
          ]
        };
        const arr = [];
        if (item.address) arr.push(item.address);
        if (item.city) arr.push(item.city);
        if (item.state) arr.push(item.state.name);
        if (item.zipCode) arr.push(item.zipCode);
        const address = arr.join(", ");
        if (address) {
          data.extraData.push([`Address: ${address}`]);
        }
        return data;
      });
    },
    primaryProviderForm: {
      get() {
        return this.form.primaryProvider;
      },
      set(newValue) {
        this.form.primaryProvider = newValue;
        const newUserCaseLoad = newValue
          ? {
              ...newValue.data,
              id: newValue.value,
              name: newValue.label
            }
          : null;
        const foundPrimaryProvider = this.insertPrimaryProvider(
          newUserCaseLoad
        );
        if (!foundPrimaryProvider && newUserCaseLoad) {
          const primaryProviderCaseRole = this.caseRoles.find(
            cR => cR.data.type == "PrimaryProvider"
          );
          const caseLoadData = {
            user: newUserCaseLoad,
            caseRole: primaryProviderCaseRole.data
          };
          this.form.caseLoads.push(caseLoadData);
        }
      }
    },
    additionalDataFields() {
      return this.form.additionalsReportResults
        ? Object.keys(this.form.additionalsReportResults)
        : [];
    }
  }
};
</script>

<style scoped>
.client-form-container >>> .tab-content {
  height: calc(100vh - 315px);
  overflow-y: auto;
  overflow-x: hidden;
}

.client-form-container >>> .nav-tabs {
  background-color: #f5f8fc;
  border-bottom: none;
  padding: 0 15px;
}

.client-form-container >>> .nav-tabs .nav-link {
  color: #777;
  font-weight: bold;
  background: none;
  border: none;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-radius: 2px;
  padding: 0.75rem 1rem;
  margin-bottom: 0;
}

.client-form-container >>> .tab-content {
  padding: 1rem;
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
  padding: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}

.section-body {
  min-height: 70px;
}
</style>
